(() => {
  if (window.letoileProductFamilyBound) return;
  window.letoileProductFamilyBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target?.closest?.('button[data-product-family-url]');
    if (!button) return;
    let target;
    try { target = new URL(button.dataset.productFamilyUrl, window.location.origin); } catch { return; }
    if (target.origin !== window.location.origin || !/^\/(?:[^/]+\/)?products\/[^/]+$/.test(target.pathname)) return;
    if (target.pathname === window.location.pathname) return;
    // Navigate to the SKU product: its complete page owns price, media and cart IDs.
    window.location.assign(target.href);
  });
})();
